export default {
	appEnv: 'production',
	apiUrl: 'https://api.graph-it.fr'
}
